import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./ResponseBank.css"; // Fichier CSS pour le style
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlaneDeparture, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import Rates from "../../components/Rates/Rates";

const ResponseBank = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Extraction du paramètre `ok_ko` de l'URL
  const queryParams = new URLSearchParams(location.search);
  const okKo = queryParams.get("ok_ko");
  const order_id = queryParams.get("order_id");

  return (
    <section id="response_bank" className="py-5">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-center">
      {okKo === "ok" ? (
        <div className="">
          <h2 className="text-dark"><FontAwesomeIcon icon={faPlaneDeparture} /> Thank you for choosing RS TRANSPORTS</h2>
          <img src="/images/hand.gif" alt="Thank you" className="response-img" />
          <p>Your reservation will be confirmed within 12 hours.</p>
          {order_id  && (
            <p> Order ID : {order_id}</p>
            )}
          <button onClick={() => navigate("/")}>Home</button>
        </div>
      ) : (
        <div className="">
          <h2 className="text-bg-danger"><FontAwesomeIcon icon={faTimesCircle} /> You did not complete your payment</h2>
          {order_id  && (
            <> Order ID : {order_id}</>
            )}
          <p>Please try again or go back to the homepage.</p>
          <button onClick={() => navigate("/")}>Home</button>
          <button onClick={() => navigate("/rates")}>Book Now</button>
          <Rates />
        </div>
      )}
    </div>
    </div>
    </section>
  );
};

export default ResponseBank;
